module.exports = __webpack_public_path__ + "30cac60b46e867ed8998ffc7030f8b1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/alby.jpg
// module id = pG9j
// module chunks = 0